<template>
  <span
    class="inline-flex w-fit items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold leading-[18px]"
    :class="LEVEL_STYLES[level].badge"
  >
    <component :is="ICONS[level]" class="size-3" aria-hidden="true" />
    {{ LEVEL_STYLES[level].label }}
  </span>
</template>

<script setup lang="ts">
import { Check, CircleAlert, TriangleAlert } from 'lucide-vue-next'

import {
  type HealthLevelType,
  LEVEL_STYLES,
} from '@/features/ui/pages/admin/dashboard/dashboard-content/program-health'

// The level of a measure: always a label and an icon, never the color alone.
defineProps<{ level: HealthLevelType }>()

const ICONS = { good: Check, watch: TriangleAlert, act: CircleAlert }
</script>
